<template>
  <div
    v-if="typeof currentProduct !== 'undefined'"
    class="produc-cta"
    :class="{ 'product-cta--loading': loading }">
    <img
      v-if="!loading" 
      :src="currentProduct.fields.mainPicture.fields.file.url"
      :alt="currentProduct.fields.mainPicture.fields.description"
      :width="currentProduct.fields.mainPicture.fields.file.details.image.width"
      :height="currentProduct.fields.mainPicture.fields.file.details.image.height" />
    <p>{{ $t('wishlist.moreInformations') }} {{ currentProduct.fields.title }}?</p>
    <button @click="$_addToWishlist">{{ $t('wishlist.putInBox') }}</button>

  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'ProductCta',
  data: () => ({
    loading: true
  }),
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'product'
    ]),
    currentProduct: {
      get () {
        return this.product(this.slug)
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts'
    ]),
    ...mapMutations('wishlist', [
      'addToWishlist'
    ]),
    $_addToWishlist() {
      this.addToWishlist(this.currentProduct)
      this.$emit('open-wishlist')
      this.$emit('change-step', {step: 0})
    },
    async loadData () {
      this.loading = true
      try {
        await this.loadProducts()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./component.scss";
</style>
